import { render, staticRenderFns } from "./choiceSortingInfo.vue?vue&type=template&id=810ba982&scoped=true"
import script from "./choiceSortingInfo.vue?vue&type=script&lang=js"
export * from "./choiceSortingInfo.vue?vue&type=script&lang=js"
import style0 from "./choiceSortingInfo.vue?vue&type=style&index=0&id=810ba982&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810ba982",
  null
  
)

export default component.exports